<template>
  <CRow>
    <CCol sm="12" v-if="loading" class="vh-100">
      <div class="d-flex justify-content-center align-items-center" style="height: 100vh">
        <CSpinner color="custom-color" style="width: 4rem; height: 4rem" />
      </div>
    </CCol>
    <template v-if="!loading">
      <CCol sm="12" class="main mb-5">
        <CRow>
          <CCol v-if="messages.length" sm="12">
            <transition name="fade">
              <MenssageAlert :messages="messages" />
            </transition>
          </CCol>
          <CCol m="12" class="main__context mt-5">
            <div>
              <a
                @click="openConfirmationBackModal()"
                class="text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600 cursor-pointer"
              >
                <CIcon name="arrow" :height="20" class="icon__rotateLeft mr-2 text-uppercase" viewBox="0 0 32 32" />
                <span>{{ $t('campaign.creator.backButton') }}</span>
              </a>
            </div>

            <div style="text-align: center" class="mt-3">
              <h3 style class="font-weight-normal text-capitalize">
                {{ $t('campaign.creator.title') }}
              </h3>
              <CForm @submit.prevent="setNameCampaign">
                <CInput
                  :readonly="campaignStatus == 3"
                  v-model="$v.campaignName.$model"
                  :isValid="checkIfValid('campaignName')"
                  maxLength="50"
                  :invalidFeedback="$t('general.inputFeedback.required-and-minLength-3')"
                  class="mt-4 inputCampaignName bg-transparent d-flex"
                  type="text"
                  ref="inputName"
                  :placeholder="$t('campaign.creator.inputNameCampaign')"
                >
                  <template #append-content>
                    <span class="inputCampaignName__append z4" v-if="!isCampaignId">
                      <CButton type="submit" :disabled="$v.$invalid" title="save">
                        <CIcon class="text-dark" size="custom-size" :height="20" viewBox="0 0 32 32" name="saveDisk" color="transparent" />
                      </CButton>
                    </span>
                  </template>
                </CInput>
              </CForm>
            </div>

            <Flow
              v-if="campaign"
              :campaign="campaign"
              :campaignStatus="campaignStatus"
              :campaignSummary="campaignSummary"
              :class="{ inactiveFlow: inactiveFlow }"
              @setLoading="changeLoading()"
              @updateConflicted="showConflictMessage"
            />
          </CCol>
        </CRow>
      </CCol>
    </template>

    <div v-if="showSaving" class="saving-position">
      <img style="width: 30px" src="img/Gif_autosave.gif" />
      <span class="ml-2 text-gray-600">{{ $t('campaign.creator.text-saving') }}</span>
    </div>

    <ModalTestRun :id="mainCampaign._id" />

    <CToaster :autohide="3000">
      <template v-if="toast.id">
        <CToast :key="'toast'" :show.sync="toast.status" header="Updade Campaign">
          <p>message : {{ toast.message }}</p>
          <p>id : {{ toast.id }}</p>
        </CToast>
      </template>
    </CToaster>

    <CModal :show.sync="showConfirmationBackModal" :closeOnBackdrop="false">
      <template #header-wrapper>
        <div class="py-3"></div>
      </template>
      <template #body-wrapper>
        <div class="font-weight-bolder">{{ $t('campaign.creator.back-modal.text') }}</div>
      </template>
      <template #footer-wrapper>
        <div class="mt-5 text-right">
          <CButton color="white" class="px-4 mr-2" @click="closeConfirmationBackModal()">{{
            $t('campaign.creator.back-modal.button.cancel')
          }}</CButton>
          <CButton color="primary" class="px-4" @click="confirmBack()">
            {{ $t('campaign.creator.back-modal.button.confirm') }}
          </CButton>
        </div>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import MenssageAlert from '@/components/MenssageAlert'
import { getItem, removeItem } from '@/utils/StorageManager'
import services from '@/services.js'
import Flow from './../components/Flow/Flow'
import ModalTestRun from './../components/ModalTestRun'

import { validationMixin } from 'vuelidate'
import { minLength, required } from 'vuelidate/lib/validators'

const campaignEnum = {
  1: 'Draft',
  2: 'Calculating',
  3: 'Ready-to-Send',
  4: 'Sent',
  5: 'On-going',
  6: 'Scheduled',
  7: 'Deleted',
}

export default {
  name: 'CampaignCreator',
  components: {
    ModalTestRun,
    MenssageAlert,
    Flow,
  },

  data() {
    return {
      loading: true,
      teste: true,
      campaignName: '',
      campaign: {},
      campaignStatus: null,
      campaignSummary: {
        totalEmailCount: null,
        totalSMSCount: null,
      },
      pageLoad: true,
      messages: [],
      activeBlock: { cardName: 'channels' },
      warningModal: false,
      fixedToasts: null,
      templateEmailPreview: '',
      modalTestRun: false,
      modalResponse: {},
      saveLoading: false,
      toast: {
        status: true,
        message: '',
        id: null,
      },
      searchTimeout: null,
      showSaving: false,
      autoSaving: null,
      inactiveFlow: true,
      showConfirmationBackModal: false,
    }
  },

  mixins: [validationMixin],

  validations: {
    campaignName: {
      required,
      minLength: minLength(1),
    },
  },

  created() {
    this.$store.commit('campaign/STOP_AUTOSAVE')

    this.loading = false
    if (this.$route.params.campaignId) {
      this.loading = true
      this.inactiveFlow = false
      this.getCampaign(this.$route.params.campaignId, this.startAutoSaving)
      return
    }
  },

  mounted() {
    this.$store.dispatch('campaign/setCurrentChannel', {
      blockLibrary: false,
      indexChannel: null,
      cardName: null,
      type: null,
      collapse: null,
    })

    if (!this.$route.params.campaignId && !this.$store.state.campaign.mainCampaign) {
      this.$router.push({ name: 'campaign' })
      return
    }

    // if (this.$refs.campaignName) this.$refs.campaignName.focus()
  },

  destroy() {
    this.campaign = {}
    this.campaignName = ''
    this.$store.dispatch('campaign/setCurrentChannel', {
      blockLibrary: false,
      indexChannel: null,
      cardName: null,
      type: null,
      collapse: null,
    })
    // clearInterval(this.autoSaving)
    this.$store.commit('campaign/STOP_AUTOSAVE')
  },

  computed: {
    mainCampaign() {
      this.setCampaign(JSON.parse(JSON.stringify(this.$store.state.campaign.mainCampaign)))
      return this.$store.state.campaign.mainCampaign
    },

    isCampaignId() {
      return this.$route.params.campaignId
    },
  },

  beforeRouteLeave(to, from, next) {
    this.campaign = {}
    this.campaignName = ''
    this.$store.commit('campaign/STOP_AUTOSAVE')
    next()
  },

  beforeDestroy() {
    // clearInterval(this.autoSaving)
    this.campaign = {}
    this.campaignName = ''
    this.$store.commit('campaign/STOP_AUTOSAVE')
  },

  methods: {
    openConfirmationBackModal() {
      this.showConfirmationBackModal = true
    },

    closeConfirmationBackModal() {
      this.showConfirmationBackModal = false
    },

    confirmBack() {
      this.saveCampaign(this.mainCampaign, this.campaignName)
      this.closeConfirmationBackModal()
      this.$router.push({ name: 'campaignList' })
    },

    changeLoading() {
      this.loading = !this.loading
    },

    checkIfValid(fieldName) {
      const field = this.$v[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },

    setCampaign(campaign) {
      this.campaign = campaign
      this.$set(this.campaign, 'values', this.loopCampaignValues(campaign.values))
    },

    loopCampaignValues(list) {
      return list.map(this.sortObjectChannels)
    },

    sortObjectChannels(obj) {
      return Object.keys(obj)
        .sort()
        .reduce((res, key) => ((res[key] = obj[key]), res), {})
    },

    startAutoSaving() {
      let autoSaving = setInterval(() => {
        if (!this.$v.$invalid && this.campaignName) {
          this.saveCampaign(this.mainCampaign, this.campaignName)
        }
      }, this.$configs.VUE_APP_SECONDS_TO_AUTOSAVE_CAMPAIGN || 15000)

      this.$store.commit('campaign/START_AUTOSAVE', autoSaving)
    },

    stopAutoSaving() {
      // clearInterval(this.autoSaving)
      this.$store.commit('campaign/STOP_AUTOSAVE')
    },

    showLoadginSave() {
      this.showSaving = true
      setTimeout(() => {
        this.showSaving = false
      }, 2000)
    },

    messageAddContentInCampaign() {
      this.messages.push(...this.$route.params.messages)

      setTimeout(() => {
        this.saveCampaign(this.mainCampaign, this.campaignName)
      }, 500)
    },

    getCampaign(id, callback) {
      this.loading = true
      this.messages = []
      let organizationId = this.$store.state.auth.organizationId

      services
        .getCampaign(organizationId, id)
        .then((response) => {
          let campaignWorkflow = response.data.data.campaignWorkflow
          this.campaignStatus = response.data.data.campaignStatus
          this.campaignSummary = response.data.data.campaignSummary
          this.campaignName = response.data.data.name
          if (campaignWorkflow) this.setMainCampaign(campaignWorkflow)

          try {
            if (this.$route.params.messages) {
              this.messageAddContentInCampaign(this.$route.params.messages)
            }
            if (this.$route.params.template.id) {
              this.setTemplateEmailInChannel(this.$route.params.template, this.$route.params.indexChannel)
            }
          } catch (error) {
            throw 'error'
          }
        })
        .catch(({ response }) => {
          if (response) {
            this.messages.push({
              status: 'danger',
              text: response.data.Message || response.data.data.Message || 'Erro',
            })
          }
        })
        .finally(() => {
          this.loading = false
          if (callback && typeof callback === 'function' && this.campaignStatus == 1) {
            callback()
          }
        })
    },

    postCampaign(mainCampaign, name) {
      if (this.$route.name != 'campaignCreatorStart') return

      this.loading = true
      this.messages = []
      let organizationId = this.$store.state.auth.organizationId

      services
        .postCampaign(organizationId, { name, campaignWorkflow: { name: name, ...mainCampaign } })
        // .postCampaign({campaignWorkflow: JSON.stringify(mainCampaign), name: name})
        .then((response) => {
          this.saveCampaignId(response.data.data.id)
          this.$router.push({
            name: 'campaignCreator',
            params: { campaignId: response.data.data.id },
          })
        })
        // TODO tratar erros
        .catch((response) => {
          this.messages.push({
            status: 'danger',
            text: response.data.Message || response.data.data.Message || 'Erro',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    patchCampaign(id, mainCampaign, name) {
      this.messages = []
      this.stopAutoSaving()
      let organizationId = this.$store.state.auth.organizationId

      services
        .patchCampaign(organizationId, id, { name, campaignWorkflow: { ...mainCampaign }, lastUpdateDateTime: new Date() })
        // .patchCampaign(id, {'campaignWorkflow': JSON.stringify(mainCampaign), 'name': name})
        .then((response) => {
          let campaignWorkflow = response.data.data.campaignWorkflow
          this.campaignName = campaignWorkflow.name
          this.saveCampaignId(response.data.data.id)
          this.setMainCampaign(campaignWorkflow)
          const hasUpdateConflict = response.data.data.campaignUpdateConflictDetected
          if (hasUpdateConflict) {
            this.showConflictMessage()
          }
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.Message || response.data.data.Message || 'Erro',
          })
        })
        .finally(() => {
          this.startAutoSaving()
        })
    },

    saveCampaign(mainCampaign, name) {
      this.saveName(name)
      let campaignId = this.$route.params.campaignId
      if (campaignId) {
        this.patchCampaign(campaignId, mainCampaign, name)
        // this.patchCampaign(campaignId, mainCampaign, name);
        this.showLoadginSave()
        return
      }
      if (this.$route.name == 'campaignCreatorStart') {
        this.postCampaign(mainCampaign, name)
        this.showLoadginSave()
      }
    },

    setMainCampaign(campaign) {
      this.$store.dispatch('campaign/setMainCampaign', campaign)
    },

    setChannelInitial(setChannel) {
      this.$store.dispatch('campaign/setCurrentChannel', setChannel)
    },

    inactiveFlowHandler(state) {
      this.inactiveFlow = state
      this.$store.dispatch('campaign/inactiveFlowHandler', state)
    },

    saveName(name) {
      this.$store
        .dispatch('campaign/saveName', name)
        .then(() => {})
        .finally(() => {})
    },

    saveCampaignId(id) {
      this.$store.dispatch('campaign/saveCampaignId', {
        id: id,
        organizationUserId: this.$store.state.auth.user.organizationUserId,
      })
    },

    setNameCampaign() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.stopAutoSaving()
        return
      }

      if (this.searchTimeout) clearTimeout(this.searchTimeout)

      this.searchTimeout = setTimeout(() => {
        this.inactiveFlowHandler(this.$v.$invalid)
        this.saveCampaign(this.mainCampaign, this.campaignName)
      }, 300)
    },

    setTemplateEmailInChannel(template, indexChannel) {
      this.$store.dispatch('campaign/setTemplateEmailInChannel', { template, indexChannel })
    },

    showConflictMessage() {
      this.messages = [
        {
          status: 'warning',
          text: this.$t('campaign.creator.update-conflict'),
        },
      ]
    },
  },

  watch: {
    campaignStatus: {
      handler(newValue) {
        if (newValue == 3) {
          this.stopAutoSaving()
        }
      },
      immediate: true,
    },
    // caso precise reiniciar o auto_save com a mudança do campaignStatus
    // campaignStatus: {
    //   handler(newValue) {
    //     console.log('a')
    //     // 1 = draft, 2 = calculating 3 = ready to send
    //     if (newValue == 1) this.$store.commit('campaign/START_AUTOSAVE', this.autoSaving)
    //   }
    // }
  },
}
</script>
<style lang="scss">
.inactiveFlow {
  pointer-events: none;
  opacity: 0.2;
}

.main {
  &__context {
    transition: width 400ms ease;
    will-change: width;
  }
}

.vh-80 {
  height: 80vh !important;
}

.inputCampaignName {
  box-shadow: none;
  margin: 0 auto;
  max-width: 500px;
  flex-direction: column;
  .input-group-append {
    position: relative;
    border: none;
    border-bottom: 1px solid #d1d4da;

    .input-group-text {
      padding: 0;
      background: none;
      border: none;
    }
  }

  .form-control {
    border: none;
    background-color: transparent;
    border-bottom: 1px solid #d1d4da;
    min-width: 300px;
    text-align: center;
    color: #7f889a;
    font-size: 14px;
    transition: 300ms;
    box-shadow: none;
    &:hover,
    &:focus {
      border-bottom: 2px solid var(--gray-base);
      box-shadow: none !important;

      & + .input-group-append {
        border-bottom: 2px solid var(--gray-base);
      }
    }
  }
}

.inputCampaignName:focus-visible {
  outline: none;
}

.saving-position {
  position: fixed;
  top: 15%;
}

*[title]:hover::after {
  content: attr(title);
  background: var(--white);
  padding: 0.1em 0.5em;
  position: absolute;
  top: 100%;
  font-size: 14px;
  left: 0;
}

.c-spinner {
  border: 0.25em solid currentColor;
  border-right-color: transparent;
}
</style>
